import { ApiBase } from './apiBase';
import { METHOD } from '../constant/api';

export class ApiAccountsAccept extends ApiBase {
  private static baseUrl: string = '/accounts/acceptterms';

  static async put(): Promise<any> {
    const url = this.baseUrl;

    const data = {};
    const config = {
      headers: { Authorization: this.token },
    };

    return await this.sendRequest(METHOD.PUT, url, data, config)
      .then((value) => {
        return value;
      })
      .catch((error) => {
        throw error;
      });
  }
}
